import {makeStyles, Theme} from '@material-ui/core/styles'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    '& > .MuiDialog-container > .MuiPaper-root': {
      [theme.breakpoints.up('xs')]: {
        minWidth: 354,
      },
      [theme.breakpoints.up('sm')]: {
        minWidth: 589,
      },
      [theme.breakpoints.up('md')]: {
        minWidth: 1300,
        height: 840,
      },
    },
    position: 'relative',
  },
  contentWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    padding: '16px 24px',
    paddingTop: 0,
  },
  closeIcon: {
    width: 20,
    height: 20,
    color: '#c5c5c5',
  },
  contentContainer: {
    padding: 8,
    borderRadius: 4,
    paddingLeft: 28,
  },
  closeButton: {
    backgroundColor: '#f4f4f4',
    width: 20,
    height: 20,
  },
  closeButtonWrap: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: '15px',
    marginTop: '10px',
  },
  guideTitle: {
    fontWeight: 700,
    fontSize: 24,
  },
}))

export default useStyles
